<div class="flex-row gap-16 full-height">
  <mat-icon class="flex-no-shrink" [svgIcon]="getIconNameForWeaveQualityType()"></mat-icon>
  <span>{{ getWeaveQualityTypeLabelForTranslate() }}</span>
</div>
